import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const tokenStore = {
  get access() {
    return localStorage.getItem("absorb_token");
  },
  get refresh() {
    return localStorage.getItem("absorb_refresh");
  },
  set(access, refresh) {
    if (access) localStorage.setItem("absorb_token", access);
    if (refresh) localStorage.setItem("absorb_refresh", refresh);
  },
  clear() {
    localStorage.removeItem("absorb_token");
    localStorage.removeItem("absorb_refresh");
  },
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = tokenStore.access;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    const isAuthCall =
      url.includes("/auth/login") ||
      url.includes("/auth/register") ||
      url.includes("/auth/refresh");

    if (status === 401 && !original._retry && !isAuthCall && tokenStore.refresh) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = axios
            .post(`${API}/auth/refresh`, { refresh_token: tokenStore.refresh })
            .then((r) => {
              tokenStore.set(r.data.token, null);
              return r.data.token;
            })
            .catch((e) => {
              tokenStore.clear();
              window.dispatchEvent(new Event("absorb:logout"));
              throw e;
            })
            .finally(() => {
              refreshing = null;
            });
        }
        const newAccess = await refreshing;
        original.headers.Authorization = `Bearer ${newAccess}`;
        return api(original);
      } catch (e) {
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
